module.exports = __webpack_public_path__ + "static/media/android-4.e66747c8.jpg";